module.exports = __webpack_public_path__ + "img/product_chart_9.391aaab3.png";